import Vue from 'vue'
import VueAxios from 'vue-axios'

import { apiRequest, mvcRequest, origamiRequest } from './axios'

Vue.prototype.$apiRequest = apiRequest
Vue.prototype.$mvcRequest = mvcRequest
Vue.prototype.$origamiRequest = origamiRequest

Vue.use(VueAxios, apiRequest)
Vue.use(VueAxios, mvcRequest)
Vue.use(VueAxios, origamiRequest)
